import { service } from '@ember/service';

import type { Service } from 'webapp-types';
import { TourId } from 'webapp/enums/tour';
import { UserSettingsKey } from 'webapp/enums/user-settings';

import WizardFirstPopupComponent from 'webapp/components/wizard/tour/popup-wizard-first';

import TourBase from 'webapp/models-custom/tour';

export default class WizardFirstTour extends TourBase {
	@service('user-settings') declare userSettingsService: Service.UserSettings;

	static keyForPersistantDone = UserSettingsKey.WIZARD_FIRST;

	override popupComponent = WizardFirstPopupComponent;

	get id(): string {
		return TourId.WIZARD_FIRST;
	}

	override get keyForPersistantDone(): string {
		return WizardFirstTour.keyForPersistantDone;
	}

	override start(): void {
		super.start();
		this.popupService
			.createModal(this.popupComponent, {
				popupClass: 'wizard wizard-first',
				allowStacked: true,
			})
			.open();
		this.markDone(); // once seen, it's done
		void this.userSettingsService.delete(UserSettingsKey.SHOW_FIRST_WIZARD); // Also need to delete show count
	}

	// no stepData - all is in modal.wizard-first
}
